import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const filterApi = createApi({
    reducerPath: 'filterApi',
    baseQuery: fetchBaseQuery({ baseUrl: "http://localhost:8443/api/v1/filter" }),
    endpoints: (builder) => ({
        addFilters: builder.mutation({
            query: (data) => ({
                url: '/add-filter',
                method: 'POST',
                body: data,
                headers: { "Content-Type": "application/json" }
            })
        }),
        getFilters: builder.query({
            query: () => ({
                url: '/get-filters',
                headers: { "Content-Type": "application/json" }
            })
        }),
        patchFilter: builder.mutation({
            query: (data) => ({
                url: '/update', // Assuming your route is PATCH /api/v1/filter/update
                method: 'PATCH',
                body: data,
                headers: { "Content-Type": "application/json" }
            })
        })
    })
});

export const { useAddFiltersMutation, useGetFiltersQuery , usePatchFilterMutation } = filterApi;
